export default __webpack_public_path__ + "static/media/relamy.a6e89dbd.svg";